export const SmallHierarchicalListName = 'smallHierarchicalListComponent';
